import PropTypes from "prop-types";
// @mui
import {
  Table,
  TableRow,
  TableBody,
  TableCell,
  TableHead,
  Typography,
  TableContainer,
} from "@mui/material";
// utils
// components
import Label from "src/components/Label";
import { formatAsINR } from "src/sections/@dashboard/general/analytics/AnalyticsTrafficBySite";
import { getStatusColor } from ".";

// ----------------------------------------------------------------------

OrderedProduct.propTypes = {
  products: PropTypes.array.isRequired,
};

export default function OrderedProduct({ products, row }) {
  return (
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Product</TableCell>
            <TableCell align="left">Status</TableCell>
            <TableCell align="left">Price</TableCell>
            <TableCell align="left">Quantity</TableCell>
            <TableCell align="right">Total Price</TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {products?.map((product, index) => {
            const { prodName, price, qty, amount } = product;
            const color = getStatusColor(product?.status);

            return (
              <TableRow key={index}>
                <TableCell>
                  <Typography
                    noWrap
                    variant="subtitle2"
                    sx={{
                      maxWidth: 190,
                      wordBreak: "break-all",
                      whiteSpace: "pre-wrap",
                    }}
                  >
                    {prodName}
                  </Typography>
                </TableCell>

                <TableCell align="left" sx={{ paddingLeft: "16px !important" }}>
                  <Label color={color || "success"}>{product?.status}</Label>
                </TableCell>
                <TableCell align="left" sx={{ paddingLeft: "16px !important" }}>
                  {formatAsINR(price)}
                </TableCell>
                <TableCell align="left" sx={{ paddingLeft: "16px !important" }}>
                  {qty}
                </TableCell>

                <TableCell
                  align="right"
                  sx={{ paddingLeft: "16px !important" }}
                >
                  {formatAsINR(amount)}
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
